import React from 'react';
import { Box, Separator, Text } from 'edenred-ui';
import { Trans, useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useTheme } from 'styled-components';
import { routerPaths } from '@epi-constants/routerPaths';
import { generateUrlWithLocale } from '@epi-selectors/navigation';
import { BoldUnstyledLink } from './CustomerCareRedirect.styles';

export function CustomerCareRedirect() {
  const { t } = useTranslation();
  const theme = useTheme();
  const loginUrl = useSelector(state =>
    generateUrlWithLocale(routerPaths.login)(state)
  );

  return (
    <>
      <Separator text={t('login_otp.separator')} />
      <Box textAlign="center">
        <Text small color={theme.gray50}>
          <Trans
            i18nKey="login_otp.support_new_code_text"
            components={{
              loginLink: (
                <BoldUnstyledLink id="login_redirect" href={loginUrl} />
              )
            }}
          />
        </Text>
        <Box py={2}>
          <Text small color={theme.gray50}>
            {t('login_otp.support_text')}
          </Text>{' '}
          <BoldUnstyledLink
            href={t('login_otp.support_link_url')}
            target="_blank"
          >
            {t('login_otp.support_link_text')}
          </BoldUnstyledLink>
        </Box>
      </Box>
    </>
  );
}
